const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const passwordRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{12,}');

function validatePasswordDetailed(password: string) {
  const validations = {
    length: password.length >= 12,
    lowercase: /[a-z]/.test(password),
    uppercase: /[A-Z]/.test(password),
    number: /[0-9]/.test(password),
    specialChar: /[!@#$%^&*()_+{}[\]:;<>,.?~\\/-]/.test(password),
    isValid: false,
  };

  validations.isValid = Object.values(validations).slice(0, 5).every(Boolean);

  return validations;
}

export { emailRegex, passwordRegex, validatePasswordDetailed };
